import { useFieldArray, useFormContext } from "react-hook-form"
import { FormattedMessage } from "react-intl"
import Button from "@rio-cloud/rio-uikit/Button"
import { ShipmentPanel } from "./ShipmentPanel"

export const ShipmentPanelList = () => {

    const { reset, getValues } = useFormContext()

    const { fields, append, remove } = useFieldArray({
        name: "shipments",
        rules: {
            required: true,
            minLength: 1,
        },
    })

    return <>
        {fields.map((field, index) =>
            <ShipmentPanel
                key={`shipment-${field.id}-of-${fields.length}`}
                shipmentIndex={index}
                removeShipment={fields.length > 1 ? () => { 
                    remove(index)
                    const values = getValues()

                    if (!values.shipments || values.shipments.length === 0) return

                    reset(values)
                } : undefined}
            />)}

        <div className={"text-center"}>
            <Button onClick={() => append({
                volume: {
                    unit: "CUBIC_METER"
                }
            })}>
                <span className={"rioglyph rioglyph-plus-light"}/>
                <FormattedMessage id={"shipment.add"}/>
            </Button>
        </div>
    </>
}
